import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from '../../core/layout/layout.service';
import { AuthService } from '../../core/auth/auth.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-verification',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './verification.component.html',
  styleUrl: './verification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerificationComponent {
  public email: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private layoutService: LayoutService, public authService: AuthService) {
    this.email = this.route.snapshot.queryParams['email'];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public onClickResend(): void {
    this.layoutService.loading = true;
  }

  public onClickCancel(): void {
    this.router.navigate(['/sign-in'], { queryParams: { redirectUrl: this.authService.redirectUrl } });
  }
}
